import { openDownloadPersistence } from "./downloadPersistence";
import { createDownloadManager } from "./downloadManager";

let downloadManagerPromise = null;

export function getDownloadManager() {
  if (!downloadManagerPromise) {
    downloadManagerPromise = openDownloadPersistence().then((db) =>
      createDownloadManager({ db })
    );
  }

  return downloadManagerPromise;
}
